import PropTypes from "prop-types";
import { usd } from "../../../../util/formatCurrency";
import s from "./ServiceSelector.module.css";

/*
 * ServiceCard — an available service the customer has not selected yet.
 *
 * Uses aria-disabled rather than the disabled attribute: a disabled button is
 * removed from the tab order, which would make the explanation of *why* it is
 * unavailable ("Maximum of 2 reached") unreachable by keyboard and screen
 * reader. The click handler is dropped instead.
 */
export default function ServiceCard({ service, disabledReason, onAdd }) {
  const isDisabled = Boolean(disabledReason);
  const priceLabel = usd(service.totalPrice);

  return (
    <button
      type="button"
      className={`${s.card} ${isDisabled ? s.cardDisabled : ""}`}
      aria-disabled={isDisabled || undefined}
      onClick={isDisabled ? undefined : () => onAdd(service)}
      aria-label={
        isDisabled
          ? `${service.label}, ${priceLabel}. ${disabledReason}`
          : `Add ${service.label}, ${priceLabel}`
      }
    >
      <span className={s.check} />
      <span className={s.info}>
        <span className={s.title}>{service.label}</span>
        {isDisabled && <span className={s.disabledText}>{disabledReason}</span>}
        {service.description && (
          <span className={s.desc}>{service.description}</span>
        )}
      </span>
      <span className={s.price}>+{priceLabel}</span>
    </button>
  );
}

ServiceCard.propTypes = {
  service: PropTypes.shape({
    influencerServiceId: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    totalPrice: PropTypes.number,
  }).isRequired,
  disabledReason: PropTypes.string,
  onAdd: PropTypes.func.isRequired,
};
